export const CHAT_QUICK_PROMPTS = [
  'When does a residential stair need lobby protection?',
  'What accessibility rules apply to student accommodation bedrooms and bathrooms?',
  'What ventilation is needed when designing flats?',
  'When is a sprinkler needed in a block of flats?',
  'How far can travel distance be inside a flat before a protected entrance door is needed?',
  'What fire escape measures are needed for a loft conversion?',
  'What sound insulation is required between flats?',
  'When are background ventilators needed in a new home?',
  'How wide should a communal stair be in an apartment building?',
  'What accessibility rules apply to toilets in a ground-floor office fit-out?',
  'When does a residential building need a second stair?',
  'What are the compartmentation rules for corridors in student accommodation?',
  'What insulation upgrades are needed for a garage conversion?',
  'What guarding height is required for balconies and internal landings?',
  'When is smoke ventilation needed in a common corridor?',
  'How many wheelchair-accessible bedrooms are required in student accommodation?',
  'What fire door is required between a house and an integral garage?',
  'When are thermostatic mixing valves needed in new homes?',
  'What headroom is required over stairs in a house extension?',
  'When does a material change of use trigger full compliance upgrades?',
] as const

export function pickRandomQuickPrompts(
  prompts: ReadonlyArray<string>,
  count: number,
): Array<string> {
  const shuffled = [...prompts]

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1))
    ;[shuffled[index], shuffled[swapIndex]] = [
      shuffled[swapIndex],
      shuffled[index],
    ]
  }

  return shuffled.slice(0, count)
}
